import { PricingTypes } from '@/enums/pricingType'

function isPerOrderAudienceValid(selectedPrincingType, prices) {
    if (selectedPrincingType && (selectedPrincingType.id) !== PricingTypes.PerOrder) {
        return true;
    }

    return Array.isArray(prices) && prices.some(p => p && p.audienceType != null);
}

export { isPerOrderAudienceValid };
 


// WEBPACK FOOTER //
// ./src/utils/pricingTypeHelpers.js